export const ShowPerPage: number = 50